<span *ngIf="showStatus">{{task.prettyStatus}}</span>
<button mat-icon-button *ngIf="task.canStop && showStartStopButton" class="status-buttons">
    <mat-icon matTooltip="Stop" (click)="stopTask($event)" class="status-mat-icons">pause</mat-icon>
</button>
<button mat-icon-button *ngIf="task.canStart && showStartStopButton" class="status-buttons">
    <mat-icon matTooltip="Start" (click)="startTask($event)" class="status-mat-icons">play_arrow</mat-icon>
</button>
<button mat-icon-button *ngIf="canShowCheckStatus&&!showProcessDetailsPopupButton" class="status-buttons">
    <mat-icon matTooltip="Check Status" (click)="checkStatus($event)" class="status-mat-icons">info</mat-icon>
</button>
<app-show-process-details-popup-button *ngIf="showProcessDetailsPopupButton"
    [process]="task"></app-show-process-details-popup-button>
<app-clear-process-threads-button *ngIf="task.isClearThreadsSupported && showClearThreadsButton"
    [process]="task"></app-clear-process-threads-button>
<app-show-task-tab-button [process]="task" style="top: 3px; position: relative;"
    *ngIf="showTaskTab && isTask && showTaskTabButton"></app-show-task-tab-button>

<app-zoning-code-reindex-button *ngIf="showReindexButton && isZoningCode" [task]="task" [zoningCode]="zoningCode"
    class="status-buttons">
</app-zoning-code-reindex-button>

<app-zoning-code-reindex-with-cursor-button *ngIf="showReindexButton && isZoningCode" [task]="task"
    [zoningCode]="zoningCode" class="status-buttons">
</app-zoning-code-reindex-with-cursor-button>

<app-zoning-code-version-recalculate-button *ngIf="showRecalculateButton && isZoningCodeVersion" [task]="task"
    [zoningCode]="zoningCode" [zoningCodeVersion]="zoningCodeVersion" class="status-buttons"
    style="top: -2px; position: relative;">
</app-zoning-code-version-recalculate-button>

<slider-for-threads *ngIf="showSlider" (threadsCountChanged)="updateTask($event)" [process]="task" [dark]="dark">
</slider-for-threads>

<app-remove-process-button *ngIf="isTask" class="status-buttons mat-icon-button" [process]="task" [isTask]="true"
    [deleteProcessEmitter]="deleteProcess"></app-remove-process-button>

<app-process-small-spinner [isVisible]="task.isWaitingActionFinish"></app-process-small-spinner>